import React from 'react'
import classnames from 'classnames'
import { useRouter } from 'next/router'
import { getQueryParam } from '../../../../utils/getQueryParam'
import style from './RegistrationLayoutFooter.module.css'
import { Copyright } from '../../../../components/Copyright/Copyright'

export const RegistrationLayoutFooter = () => {
  const { query } = useRouter()
  const widget = getQueryParam(query, 'widget')

  const className = classnames(style.layout, {
    [style.mobileLayout]: !widget,
  })

  return (
    <div className={className}>
      <Copyright />
    </div>
  )
}

RegistrationLayoutFooter.displayName = 'RegistrationLayoutFooter'
